var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group",attrs:{"id":"contenedorLista"}},[_c('chat',{attrs:{"buscar":_vm.recibiendo,"etiqueta":_vm.tipoEtiqueta}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }